import { connect } from 'react-redux';
import { Card, Row, Col } from 'react-bootstrap';
import BaseFeature from './BaseFeature';
import { DIM_SETTINGS } from '../../../../../../utils/constantFeatures';
import PropertyPicker from './components/PropertyPicker';

class DimSettings extends BaseFeature {

    constructor(props) {
        super(props);

        this.state = {

        };

        this.handleChange = this.handleChange.bind(this);

    }

    handleChange(propertyName, value) {
        const v = value;
        const newState = {[propertyName]:value};

        this.setState(newState);

        const state = { ...this.state, ...newState };
        // this.setState({ dimmingEnabled: v === "1" ? true : false });

        this.props.handleChange(propertyName, v);
    }

    render() {

        return (
            <><Row>
                <Col lg={6} md={6} sm={12}>
                    <Card className="card-feature-component" style={{ width: '100%'}}>
                        <div className="card-header-feature">
                            {'Dim Settings'}
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem'}} >

                            <PropertyPicker
                            // disabled={this.props.properties[ADJUSTABLE_DIM.enable].value === '1' ? false : true}
                                property={this.props.properties[DIM_SETTINGS.minDimming]}
                                title={this.props.properties[DIM_SETTINGS.minDimming].info.displayName + ""}
                                margin="0.75rem auto"
                                // measureUnit={this.props.properties[DIMMING.dimmingMin].info.unit}
                                min={this.props.properties[DIM_SETTINGS.minDimming].valueMeta.min}
                                max={this.props.properties[DIM_SETTINGS.minDimming].valueMeta.max}
                                inputStyle={{ padding: "0", maxWidth: "auto" }}
                                titleSize={10}
                                inputSize={2}
                                step={1}
                                handleChange={this.handleChange} />

                        </Card.Body>
                    </Card>
                </Col>

            </Row></>
        );
    }

}

export default connect(
    // mapStateToProps,
    // mapDispatchToProps
)(DimSettings);
